import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 锦囊产品分页
 * @param data
 */
export function getAuthorJinNangList(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/ConsoleData/ProductPage`,
    method: 'post',
    data,
    headers: {
      'Ykt-ViewState': viewState
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 获取锦囊详情
 * @param data
 */
export function getJinNangDetail(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/ConsoleData/ProductSummary`,
    method: 'post',
    data
  })
    .then(result => {
      return result.detail
    })
    .catch(() => null)
}

/**
 * 获取锦囊交易动态
 * @param data
 */
export function getAuthorJinNangTradePage(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/ConsoleData/GetTradePage`,
    method: 'post',
    data,
    headers: {
      'Ykt-ViewState': viewState
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 委托撤单
 * @param data
 */
export function authorJinNangSecuCancle(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/ConsoleData/SecuCancle`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 获取锦囊仓位详情
 * @param data
 */
export function getJinNangRepoList(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/ConsoleData/RepoList`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 获取锦囊收益曲线
 * @param data
 */
export function getJinNangYieldList(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/ConsoleData/Yieldlist`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 查询可持仓最小 最大仓位
 * @param  data
 * @returns
 */
export function getMaxPos(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/ConsoleData/GetBsAmt`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 委托下单
 * @param  data
 * @returns
 */
export function secuEntrust(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/ConsoleData/SecuEntrust`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 锦囊申请
 * @param  data
 * @returns
 */
export function jinNangApply(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/ConsoleData/Apply`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 获取买卖五档
 * @param data
 */
export function getFiveStall(data) {
  return axios({
    url: `${Urls.DOMAIN_SECURE}ds`,
    method: 'post',
    data,
    headers: {
      'X-Protocol-Id': 3000,
      'X-Request-Id': '1',
      'Content-Type': 'application/json'
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

export function getStock(data) {
  return axios({
    url: `${Urls.DOMAIN_SECURE}ds`,
    method: 'post',
    data: {
      ...data,
      fieldsId: [1, 0, 6, 106, 1029, 1030]
    },
    headers: {
      'X-Protocol-Id': 2200,
      'X-Request-Id': '1',
      'Content-Type': 'application/json'
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}
